module.exports = __webpack_public_path__ + "static/img/scatter@2x.505443e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scatter@2x.png
// module id = e4p+
// module chunks = 7